import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link } from 'react-router-dom';
import Select from 'react-select';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

// Tabs
import ContractsEditTab from './Elements/ContractsEditTab';
import getLocale from '../../i18n/getLocale';
class ContractsEdit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      key: 1,
      contract_data: {},
      contract_backups: [],
      aircrafts_list: {},
      bases_list: {},
      certifications_list: {},
      roles_list: {},
      designations_list: [],
      certifications_experience_list: {},
      designation_requisitions_list: [],
      designation_groups_list: [],
      designation_custom_requisitions_list: [],
      contract_exceptions: [],
      contract_experiences: {},
      contract_flights: [],
      clients_list: {},
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.locale = getLocale();

    this.loadData = this.loadData.bind(this);
    this.addException = this.addException.bind(this);
    this.deleteException = this.deleteException.bind(this);
  }

  handleSelectChangeDesignation(name, event) {
    var change = {};
    var self = this;
    if(event == null) {
      change[name] = null;
      self.setState({designation_requisitions_list: []});
      self.setState({designation_groups_list: []});
      self.setState({designation_custom_requisitions_list: []});
    } else {
      change[name] = event.value;
      var header = this.refs.request_api.header('application/json');
      self.handleAlert('', '', 'open');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/designacoes/requisicoes/lista/'+event.value+'/'+self.props.match.params.id, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson);
          if (responseJson.status === 'success') {
            self.setState({designation_requisitions_list: responseJson.data.designation_requisitions_list});
            self.setState({designation_groups_list: responseJson.data.designation_groups_list});
            self.setState({designation_custom_requisitions_list: responseJson.data.designation_custom_requisitions_list});
          }
          self.handleAlert('', '', 'closed');
          }).catch((error) => {
          console.error(error);
        });
      });
    }
    change['designation_group_id'] = null;
    change['designation_requisition_id'] = null;
    change['designation_custom_requisition_id'] = null;
    this.setState(change);
  }

  handleSelectChangeRequisition(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    change['designation_custom_requisition_id'] = null;
    change['designation_group_id'] = null;
    this.setState(change);
  }

  handleSelectChangeGroup(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    change['designation_custom_requisition_id'] = null;
    change['designation_requisition_id'] = null;
    this.setState(change);
  }
  handleSelectChangeCustom(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    change['designation_requisition_id'] = null;
    change['designation_group_id'] = null;
    this.setState(change);
  }
  
  // Handlers
  handleNavTab(state, key) {
    var change = {};
    change[state] = key;
    this.setState(change);
    this.setState({overlay: {message: '', type: '', status: ''}});
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  //LM
  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData (event) {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/contrato/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url', '/contratos');
        if (responseJson.status === 'success') {
          self.setState({contract_data: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/contrato/backups/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url', '/contratos');
        if (responseJson.status === 'success') {
          self.setState({contract_backups: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/bases/lista';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({bases_list: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/aeronaves/lista';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({aircrafts_list: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/certificados/lista';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({certifications_list: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/designacoes/lista';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({designations_list: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/clientes/lista';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({clients_list: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/contrato/excecoes/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({contract_exceptions: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/contrato/voos/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({contract_flights: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        if (typeof event === 'undefined') {
          self.handleMessage();
        } else {
          self.handleAlert(event.message, event.status, 'open');
        }
      });  });  });  });  });  });  });   });  });
    });
  }


  addException(event) {
    var self = this;
    event.preventDefault();
    self.handleAlert('', '', 'open');

    var datasave = {
      contract_id: this.props.match.params.id,
      designation_id: this.state.designation_id,
      designation_requisition_id: this.state.designation_requisition_id,
      designation_group_id: this.state.designation_group_id,
      designation_custom_requisition_id: this.state.designation_custom_requisition_id,
    };
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/contrato/excecao', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({contract_exceptions: responseJson.data});
        }
        self.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  deleteException(id) {
    if(window.confirm(this.locale.Contratos.EditarContrato.deletar)) {
      var self = this;
      self.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/contrato/excecao/'+id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({contract_exceptions: responseJson.data});
          }
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  render() {
    var self = this;
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">{this.locale.Contratos.EditarContrato.titulo}</h3>
      <Link to="/contratos" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> {this.locale.general.voltar}</Link>
      <div className="clearfix"></div>
      <hr/>
      <ContractsEditTab handleAlert={this.handleAlert} contract_id={this.props.match.params.id} aircrafts_list={this.state.aircrafts_list} bases_list={this.state.bases_list} clients_list={this.state.clients_list} contract_data={this.state.contract_data} contract_backups={this.state.contract_backups} />
      <hr />
      <h4>{this.locale.Contratos.EditarContrato.adicionarExcecao}</h4>
      <form onSubmit={this.addException}>
        <div className="row">
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.Contratos.EditarContrato.formulario.Designacao}:</label>
              <Select
                className="form-field-name"
                name="designation_id"
                value={this.state.designation_id}
                searchable={true}
                placeholder={this.locale.Contratos.EditarContrato.formulario.placeholder.SelecionarDesignacao}
                onChange={this.handleSelectChangeDesignation.bind(this, 'designation_id')}
                options={this.state.designations_list}
              />
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.Contratos.EditarContrato.formulario.HorasDeVoo}:</label>
              <Select
                className="form-field-name"
                name="designation_requisition_id"
                value={this.state.designation_requisition_id}
                searchable={true}
                placeholder={this.locale.Contratos.EditarContrato.formulario.placeholder.SelecionarRequisito}
                onChange={this.handleSelectChangeRequisition.bind(this, 'designation_requisition_id')}
                options={this.state.designation_requisitions_list}
              />
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.Contratos.EditarContrato.formulario.Personalizados}:</label>
              <Select
                className="form-field-name"
                name="designation_custom_requisition_id"
                value={this.state.designation_custom_requisition_id}
                searchable={true}
                placeholder={this.locale.Contratos.EditarContrato.formulario.placeholder.SelecionarRequisito}
                onChange={this.handleSelectChangeCustom.bind(this, 'designation_custom_requisition_id')}
                options={this.state.designation_custom_requisitions_list}
              />
            </div>
          </div>
        </div>
        <button type="submit" className="btn btn-primary btn-inline btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.Contratos.EditarContrato.formulario.botaoAdicionarRequisito}</button>
      </form>
      <hr />
        <table className="table">
        <thead>
          <tr>
            <th>{this.locale.Contratos.EditarContrato.tabelaDesignacao.Designacao}</th>
            <th>{this.locale.Contratos.EditarContrato.tabelaDesignacao.Tipo}</th>
            <th>{this.locale.Contratos.EditarContrato.tabelaDesignacao.RequisitoExcepcional}</th>
            <th>{this.locale.Contratos.EditarContrato.tabelaDesignacao.Acoes}</th>
          </tr>
        </thead>
        <tbody id="requisicoes">
        {Object.keys(self.state.contract_exceptions).map(function(k) {
          return (
            <tr>
              <td>{self.state.contract_exceptions[k].designation}</td>
              <td>{self.state.contract_exceptions[k].type}</td>
              <td>{self.state.contract_exceptions[k].name}</td>
              <td>
                <button className="btn btn-sm btn-danger" onClick={() => self.deleteException(self.state.contract_exceptions[k].id)}>
                  <i className="fa fa-fw fa-trash"></i>
                </button>
              </td>
            </tr>
          );
        })}
        </tbody>
      </table>
      <div className="clearfix"></div>
      <hr/>
      <h4>{this.locale.Contratos.EditarContrato.tabelaPrimeiroEUltimoVoo.titulo}</h4>
      <hr/>
      <table className="table">
        <thead>
          <tr>
            <th>{this.locale.Contratos.EditarContrato.tabelaPrimeiroEUltimoVoo.ID}</th>
            <th>{this.locale.Contratos.EditarContrato.tabelaPrimeiroEUltimoVoo.NumDoVoo}</th>
            <th>{this.locale.Contratos.EditarContrato.tabelaPrimeiroEUltimoVoo.Data}</th>
          </tr>
        </thead>
        <tbody id="voos">
        {Object.keys(self.state.contract_flights).map(function(k) {
          return (
          <tr>
            <td>{self.state.contract_flights[k].id}</td>
            <td>{self.state.contract_flights[k].flight_number}</td>
            <td>{self.state.contract_flights[k].date_str}</td>
          </tr>
          );
        })}
        </tbody>
      </table>
    </div>
  </div>
</div>
    );
  }
}

export default ContractsEdit;



// WEBPACK FOOTER //
// ./src/Components/Contracts/ContractsEdit.js